<template>
  <v-snackbar dir="rtl"

              :color="$store.getters.get_snack_bar_color"
              v-model="$store.getters.get_snack_bar.show"
  >
    {{ $store.getters.get_snack_bar.text }}
    <template v-slot:action="{ attrs }">

      <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="hide"
      >
        بستن
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",
  methods: {
    hide(state) {
      this.$store.commit('hide_snackbar', state)
    }
  }
  , computed: {
    color() {
      return this.$store.getters.get_snack_bar_color;
    }
  }
}
</script>

<style scoped>

</style>
